import { isUndecidedDate } from '@/components/Calendar';
import { DateUtils } from '@/helpers/dateUtils';
import { CartValuesServiceStore } from '@/store/shoppingCart/shoppingCartStore';
import { LuCalendar, LuTrash2 } from 'react-icons/lu';
import styled from 'styled-components';
import WaveSideSvg from '@/assets/icons/splitScreen.svg?react';
import { Format } from '@/helpers/formatters';
import { ButtonWithIcon } from '@/components/IconButton';

const Container = styled.div`
    display: flex;
    padding: 0.75rem 0rem;
    gap: 0.5rem;
    align-items: center;

    .column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.5rem;

        p.title {
            color: var(--Neutral-800, #27272a);
            font-family: 'Hero New';
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.05rem; /* 120% */
            margin: 0;
        }

        .row {
            display: flex;
            gap: 0.25rem;

            .icon-label {
                display: flex;
                align-items: center;
                gap: 0.25rem;
                color: var(--Neutral-500, #71717a);
                font-family: 'Hero New';
                font-size: 0.75rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1.05rem;

                svg {
                    width: 1rem;
                    height: 1rem;
                    color: #71717a;

                    &.inverted {
                        transform: rotate(180deg);
                    }

                    &.wave {
                        fill: #71717a;
                    }
                }
            }
        }
    }

    .divider {
        height: 100%;
        width: 2px;
        border-radius: 0.5625rem;
        /* background: var(--Neutral-200, #e4e4e7); */
        background-color: red;
    }

    p.price {
        color: var(--Neutral-800, #27272a);
        font-family: 'Hero New';
        font-size: 1rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.2rem; /* 120% */
        margin: 0;
        margin-left: auto;

        &.free {
            color: var(--Neutral-300, #d4d4d8);
        }
    }
`;

export const SidebarCartItem = ({
    item,
    setCurrentIdRemoving,
}: {
    item: CartValuesServiceStore;
    setCurrentIdRemoving: (currentIdRemoving: string | null) => void;
}) => {
    return (
        <Container>
            <div className="column">
                <p className="title">{item.title}</p>
                <div className="row">
                    <span className="icon-label">
                        <LuCalendar />
                        {DateUtils.formatPossibleDate(item.date)}
                        {!isUndecidedDate(item.date) &&
                            item.scheduleHour &&
                            ` às ${item.scheduleHour}`}
                    </span>
                    {item.waveSide && (
                        <span className="icon-label">
                            {item.waveSide === 'Left' ? (
                                <WaveSideSvg className="wave" />
                            ) : (
                                <WaveSideSvg className="wave inverted" />
                            )}
                            {item.waveSide === 'Left' ? 'Esquerda' : 'Direita'}
                        </span>
                    )}
                </div>
            </div>
            <p className={'price ' + (item.value === 0 ? 'free' : '')}>
                {Format.currency(item.value)}
            </p>
            <div className="divider"></div>
            <ButtonWithIcon
                variant={['red', 'empty']}
                children={<LuTrash2 />}
                onClick={() => setCurrentIdRemoving(item.idCart!)}
            />
        </Container>
    );
};

/*
<ElementCartWrap key={index}>
                                        <ElementsTextInfosWrap>
                                            <span>{cartElement.title}</span>


                                            <Box style={{ gap: '0.65rem' }}>
                                                <Box
                                                    style={{
                                                        gap: '0.25rem',
                                                    }}
                                                >
                                                    <ReactIcon
                                                        Icon={LuCalendar}
                                                        size={'1rem'}
                                                        color="#71717A"
                                                    />
                                                    <HoursElementsText>
                                                        {DateUtils.formatPossibleDate(
                                                            cartElement.date
                                                        )}
                                                    </HoursElementsText>
                                                </Box>
                                                {cartElement.scheduleHour && !isUndecidedDate(cartElement.date) && (
                                                    <Box
                                                        style={{
                                                            gap: '0.25rem',
                                                        }}
                                                    >
                                                        <ReactIcon
                                                            Icon={LuClock3}
                                                            size={'1rem'}
                                                            color="#71717A"
                                                        />
                                                        <HoursElementsText>
                                                            {
                                                                cartElement.scheduleHour
                                                            }
                                                        </HoursElementsText>
                                                    </Box>
                                                )}
                                            </Box>
                                        </ElementsTextInfosWrap>

                                        <ValuesCartWrap>
                                            <h2>
                                                {Format.currency(
                                                    cartElement.value
                                                )}
                                            </h2>
                                            <ReactIcon
                                                Icon={LuTrash}
                                                size={'1.25rem'}
                                                cursor={'pointer'}
                                                color="#71717A"
                                                onClick={() => {
                                                    setCurrentIdRemoving(
                                                        cartElement.idCart!
                                                    );
                                                }}
                                            />
                                        </ValuesCartWrap>
                                    </ElementCartWrap>

*/
